import React from "react"
import PropTypes from "prop-types"
import { Redirect } from "react-router"
import routes from "../../routes"
import { formatRoute } from "react-router-named-routes"

const CaseDetailRedirect = (props) => {
  return props.facilityId && props.caseId ? (
    <Redirect
      to={formatRoute(routes.caseDetail, {
        facilityId: props.facilityId,
        caseId: props.caseId,
      })}
      push={true}
    />
  ) : null
}

CaseDetailRedirect.propTypes = {
  caseId: PropTypes.string,
  facilityId: PropTypes.string,
}

export default CaseDetailRedirect
